import * as types from '../action/actionTypes';
import initialState from './initialState';

export default function EmployeeReducer(state = initialState.TenantEmployee, action) {
    switch (action.type) {
        case types.GET_EMPLOYEE_REGULAREXPRESSION_SUCCESSFULL: return {
            ...state, RegularExpression: action.getResponse,
         };
        default : return state; 
    }   
}